<script>
export default {
  name: "CrmPrivilegeCard",
  props: {
    item: {
      type: Object,
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    showDescription: {
      type: Boolean,
      default: false
    },
    dataTest: {
      type: String,
      required: true
    },
    actionDataTest: {
      type: String,
      default: ""
    },
    history: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  emits: ["select", "use"],
  computed: {
    title() {
      return this.item.coupon_language?.[0]?.name || this.item.name || "-";
    },
    description() {
      return this.item.detail || this.item.description || "";
    },
    image() {
      return (
        this.item.image_url || require("@/assets/images/default-image.png")
      );
    },
    typeLabel() {
      const source = [
        this.item.privilege_language?.[0]?.name,
        this.item.privilege_name,
        this.item.channel_name,
        this.item.channel,
        this.item.type_name,
        this.item.coupon_language?.[0]?.name,
        this.item.name,
        this.item.detail
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      if (source.includes("online") || source.includes("ออนไลน์")) {
        return this.$t("privilege_channel_online");
      }

      return this.$t("privilege_channel_store");
    },
    badgeClass() {
      return this.typeLabel === this.$t("privilege_channel_online")
        ? "is-online"
        : "is-store";
    },
    isExpired() {
      if (this.item.availability === 0 || this.item.already_use === 1)
        return true;
      if (!this.item.expired_date) return false;
      return this.$moment(this.item.expired_date).valueOf() < Date.now();
    },
    statusLabel() {
      if (this.item.already_use === 1) return this.$t("already_used");
      return this.$t("expired");
    },
    expiredDate() {
      if (!this.item.expired_date) return "-";
      return this.$moment(this.item.expired_date).format("DD MMM YYYY");
    }
  }
};
</script>

<template>
  <article
    :class="[
      'crm-privilege-card',
      {
        'crm-privilege-card--compact': compact,
        'is-expired': history
      }
    ]"
    :data-test="dataTest"
    @click="$emit('select', item)"
  >
    <div class="crm-privilege-card__media">
      <c-img-lazy :src="image" class="crm-privilege-card__image" />
      <!-- <span :class="['crm-privilege-card__badge', badgeClass]">
        {{ typeLabel }}
      </span> -->
    </div>
    <div class="crm-privilege-card__body">
      <h3 class="crm-privilege-card__title">{{ title }}</h3>
      <p v-if="showDescription" class="crm-privilege-card__description">
        {{ description }}
      </p>

      <div class="crm-card__meta">
        <span>{{ $t("redeem_date") }} </span>
        <span class="text-nowrap">{{ expiredDate }}</span>
      </div>
      <!-- class="crm-privilege-card__button" -->
      <c-btn
        type="button"
        variant="outline-primary"
        autoWidth
        class="mt-auto"
        :data-test="actionDataTest || `${dataTest}-use-btn`"
        @click.stop="$emit('use', item)"
        :disabled="isHistory"
      >
        {{ isHistory ? statusLabel : $t("use_coupon") }}
      </c-btn>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.crm-privilege-card {
  display: grid;
  position: relative;
  isolation: isolate;
  --ticket-notch-x: 37%;
  --ticket-notch-radius: 17px;
  grid-template-columns: 37% minmax(0, 1fr);
  min-height: 122px;
  border: 0;
  border-radius: var(--crm-border-radius);
  background: transparent;
  box-shadow: none;
  cursor: pointer;
  // -webkit-mask: radial-gradient(
  //     circle var(--ticket-notch-radius) at var(--ticket-notch-x) 0,
  //     transparent 99%,
  //     #000 100%
  //   ),
  //   radial-gradient(
  //     circle var(--ticket-notch-radius) at var(--ticket-notch-x) 100%,
  //     transparent 99%,
  //     #000 100%
  //   );
  // mask: radial-gradient(
  //     circle var(--ticket-notch-radius) at var(--ticket-notch-x) 0,
  //     transparent 99%,
  //     #000 100%
  //   ),
  //   radial-gradient(
  //     circle var(--ticket-notch-radius) at var(--ticket-notch-x) 100%,
  //     transparent 99%,
  //     #000 100%
  //   );
  // -webkit-mask-composite: source-in;
  // mask-composite: intersect;
}

.crm-privilege-card::before,
.crm-privilege-card::after {
  position: absolute;
  inset: 0;
  z-index: 0;
  border-radius: var(--crm-border-radius);
  content: "";
  pointer-events: none;
  // -webkit-mask: radial-gradient(
  //     circle var(--ticket-notch-radius) at var(--ticket-notch-x) 0,
  //     transparent 99%,
  //     #000 100%
  //   ),
  //   radial-gradient(
  //     circle var(--ticket-notch-radius) at var(--ticket-notch-x) 100%,
  //     transparent 99%,
  //     #000 100%
  //   );
  // mask: radial-gradient(
  //     circle var(--ticket-notch-radius) at var(--ticket-notch-x) 0,
  //     transparent 99%,
  //     #000 100%
  //   ),
  //   radial-gradient(
  //     circle var(--ticket-notch-radius) at var(--ticket-notch-x) 100%,
  //     transparent 99%,
  //     #000 100%
  //   );
  // -webkit-mask-composite: source-in;
  // mask-composite: intersect;
}

.crm-privilege-card::before {
  background: #fff;
}

.crm-privilege-card::after {
  // box-shadow: inset 0 0 0 2px #d7e0ea;
  box-shadow: var(--crm-box-shadow);
}

.crm-privilege-card--compact {
  width: 350px;
  --ticket-notch-x: 38%;
  grid-template-columns: 38% minmax(0, 1fr);
  flex: 0 0 auto;
  min-height: 110px;
}

.crm-privilege-card__media {
  position: relative;
  z-index: 1;
  min-width: 0;
  overflow: hidden;
  border-radius: var(--crm-border-radius) 0 0 var(--crm-border-radius);
  background: #f4f4f4;
}

.crm-privilege-card__media::after {
  position: absolute;
  inset: 0;
  background: transparent;
  content: "";
  pointer-events: none;
  transition: background 0.2s ease;
}

.crm-privilege-card__image {
  width: 100%;
  height: 100%;
}

.crm-privilege-card__image :deep(.v-img) {
  height: 100%;
}

.crm-privilege-card__badge {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 92%;
  padding: 8px 14px;
  border-radius: 0 0 18px 0;
  background: #ffe5de;
  color: var(--primary-color);
  font-size: var(--font-body);
  font-weight: 800;
}

.crm-privilege-card__badge.is-online {
  background: #eee5ff;
  color: #7461ff;
}

.crm-privilege-card__badge.is-store {
  background: #fff1dc;
  color: var(--primary-color);
}

.crm-privilege-card__body {
  display: flex;
  position: relative;
  z-index: 1;
  min-width: 0;
  flex-direction: column;
  padding: 12px 16px;
  background-color: var(--secondary-color);
  border-radius: 0 var(--crm-border-radius) var(--crm-border-radius);
}

.crm-privilege-card__title {
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  color: #050505;
  font-size: var(--font-body);
  font-weight: 400 !important;

  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.crm-privilege-card--compact .crm-privilege-card__title {
  font-size: var(--font-body);
}

.crm-privilege-card__description {
  display: -webkit-box;
  overflow: hidden;
  margin: 5px 0 0;
  color: #a0a0a0;
  font-size: var(--font-body-sm);
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.crm-privilege-card__button {
  flex: 0 0 auto;
  min-width: 76px;
  // min-height: 42px;
  // padding: 8px 14px;
  border: 0;
  border-radius: 8px;
  background: var(--button-color);
  color: #fff; /* white on primary-color bg */
  font-weight: 800;
  margin-top: auto;
}

.crm-privilege-card__button:disabled {
  background: #dedede;
  color: #b0b0b0; /* disabled state */
}

.crm-privilege-card.is-expired .crm-privilege-card__media {
  background: #fbfbfb;
}

.crm-privilege-card.is-expired .crm-privilege-card__media::after {
  background: rgba(255, 255, 255, 0.62);
}

.crm-privilege-card.is-expired .crm-privilege-card__image {
  filter: saturate(0.55) contrast(0.9) brightness(1.12);
}

.crm-privilege-card.is-expired .crm-privilege-card__badge {
  background: rgba(255, 255, 255, 0.7);
  color: #ffffff;
}

.crm-privilege-card.is-expired .crm-privilege-card__title {
  color: #9c9c9c;
}

// .crm-privilege-card.is-expired .crm-privilege-card__meta {
//   color: #dddddd;
// }

// .crm-privilege-card.is-expired .crm-privilege-card__meta strong {
//   color: #ff8f8f;
// }

.crm-privilege-card.is-expired .crm-privilege-card__button:disabled {
  background: transparent;
  color: #d2d2d2;
}
</style>
